import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Project } from '../../types';

interface ProjectsSlice {
  myProjects: Project[];
  page: number;
  limit: number;
}

const initialState: ProjectsSlice = {
  myProjects: [],
  page: 1,
  limit: 10,
};

const registrationSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    setMyProjects: (state, action: PayloadAction<Project[]>) => {
      state.myProjects = action.payload;
    },
    nextPage: (state) => {
      state.page += 1;
    },
    prevPage: (state) => {
      state.page -= 1;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
  },
  selectors: {
    selectProjects: (state) => state.myProjects,
    selectProjectsPage: (state) => state.page,
    selectProjectsLimit: (state) => state.limit,
  },
});

export const { nextPage, prevPage, setLimit, setMyProjects, setPage } =
  registrationSlice.actions;

export const { selectProjects, selectProjectsLimit, selectProjectsPage } =
  registrationSlice.selectors;

export default registrationSlice.reducer;
